




































































































































import { Component } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import ajax from "../../../lib/ajax";
import AppConsts from "../../../lib/appconst";
@Component
export default class StoreDetail extends AbpBase {
  remote: string = AppConsts.remoteServiceBaseUrl;
  memberColumns = [
    {
      title: "用户ID",
      key: "id",
      align: "center"
    },
    {
      title: "姓名",
      key: "name",
      align: "center"
    },
    {
      title: "等级",
      key: "memberLevel",
      align: "center"
    },
    {
      title: "推荐人",
      key: "invitator",
      align: "center"
    },
    {
      title: "手机号码",
      key: "phoneNumber",
      align: "center"
    },
    {
      title: "订单量",
      key: "orderCount",
      align: "center"
    },
    {
      title: "标签",
      slot: "label",
      align: "center"
    },
    {
      title: "操作",
      slot: "action",
      align: "center"
    }
  ];
  memberData = [];
  memberTable: any = {
    pageSize: 10,
    currentPage: 1,
    totalCount: 0
  };
  stockColumns = [
    {
      title: "货号",
      key: "productCode",
      align: "center"
    },
    {
      title: "商品图片",
      slot: "commodityImageUrl",
      align: "center"
    },
    {
      title: "商品名称",
      key: "commodityName",
      align: "center"
    },
    {
      title: "所属分类",
      key: "classificationTitle",
      align: "center"
    },
    {
      title: "零售价",
      slot: "price",
      align: "center"
    },
    {
      title: "SKU",
      key: "skuCount",
      align: "center"
    },
    {
      title: "库存",
      key: "stockQuantity",
      align: "center"
    },
    {
      title: "操作",
      slot: "action",
      align: "center"
    }
  ];
  stockData = [];
  stockTable: any = {
    pageSize: 10,
    currentPage: 1,
    totalCount: 0
  };
  storeInfo: any = {};
  storeTypeList: any[] = ["加盟", "代理", "联营", "直营"];
  SKUInfo: any[] = [];
  showSKUInfo: boolean = false;

  created() {
    this.getStoreForView();
    this.getMemberList();
    this.getStoreCommodityList();
  }
  // 更新店铺状态
  updateChannelActivity() {
    ajax
      .put(`api/services/app/Channel/UpdateChannelActivity`, {
        channelId: this.$route.params.id
      })
      .then(res => {
        if (res.data.success) {
          this.$Message.success("操作成功");
        }
      })
      .catch(err => {
        this.getStoreForView();
      });
  }
  // 获取店铺商品的库存
  getCommoditySKUForStoreList(commodityId) {
    ajax
      .get(
        `api/services/app/CommodityForStore/GetCommoditySKUForStoreList?StoreId=${this.storeInfo.id}&CommodityId=${commodityId}`
      )
      .then(res => {
        this.SKUInfo = res.data.result.items;
        this.showSKUInfo = true;
      });
  }
  // 获取店铺信息（用于查看）
  getStoreForView() {
    ajax
      .get(`api/services/app/Store/GetStoreForView?Id=${this.$route.params.id}`)
      .then(res => {
        this.storeInfo = res.data.result;
      });
  }
  // 获取会员列表
  getMemberList() {
    ajax
      .get(
        `api/services/app/Store/GetMemberList?Id=${
          this.$route.params.id
        }&MaxResultCount=${this.memberTable.pageSize}&SkipCount=${(this
          .memberTable.currentPage -
          1) *
          this.memberTable.pageSize}`
      )
      .then(res => {
        this.memberData = res.data.result.items;
        this.memberTable.totalCount = res.data.result.totalCount;
      });
  }
  // 获取会员列表
  getStoreCommodityList() {
    ajax
      .get(
        `api/services/app/Store/GetStoreCommodityList?Id=${
          this.$route.params.id
        }&MaxResultCount=${this.memberTable.pageSize}&SkipCount=${(this
          .memberTable.currentPage -
          1) *
          this.memberTable.pageSize}`
      )
      .then(res => {
        this.stockData = res.data.result.items;
        this.stockTable.totalCount = res.data.result.totalCount;
      });
  }
}
